import React from 'react'
import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import api from '../apis/messageManagementAPI'
import alertMessage from '../utils/alertMessage'
import {Typography} from 'antd'

const {Text} = Typography


export default class MessageDetailStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable isFetchingLog = false
  @observable isFetchingPayload = false
  @observable isFetchingPayloadFormat = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable
  searchItem = {
    startTime: '',
    endTime: '',
    direction: '',
    messageStatus: '',
    ingestionNames: [],
    messageId: [],
    related: false,
  }
  @observable allMessageList = []
  @observable messageList = []
  @observable messageLog = []
  @observable messagePayload = {}
  @observable messagePayloadModal = {}

  @observable tabsValue = 'APIInformationSearch'

  @action
  changeTabsValue(value) {
    this.tabsValue = value
  }

  /*overView tab 1*/
  @action
  async searchMessageOverview(params, pageNo, pageSize, searchParams) {
    this.isFetching = true
    this.messageList = []
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.itemCount = 0
    try {
      const response = await api.searchMsgListAction(params, pageNo ? pageNo : 1, pageSize ? pageSize : this.pageSize)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          if (response.data.data === null) {
            alertMessage.error('Failed！ Data Platfrom no data!')
          } else {
            this.messageList = response.data.data.records.sort(function (a, b) {
              return a.startTime < b.startTime ? 1 : -1
            }) || []
            // if(searchParams!==undefined) {
            //   this.messageList = this.allMessageList.slice(0,10)
            //   this.pageSize = 10
            // }else {
            //   this.messageList= this.allMessageList
            //   this.pageSize = pageSize || this.pageSize
            // }

            this.itemCount = response.data.data?.total
            this.pageNo = pageNo
            this.searchItem = params
          }
        } else {
          alertMessage.error(response.data.messageEn)
        }
      })
      return response
    } catch (error) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*overView tab 2*/
  @action
  async onSearchMsgListAction(params, pageNo, pageSize) {
    this.isFetching = true
    this.messageList = []
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.itemCount = 0
    try {
      const response = await api.searchMsgListIdentificationAction(params, pageNo ? pageNo : 1, pageSize ? pageSize : this.pageSize)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.messageList = response.data.data.records.sort(function (a, b) {
            return a.startTime < b.startTime ? 1 : -1
          }) || []
          // this.messageList = this.allMessageList.slice(0,this.pageSize)
          this.itemCount = response.data.data?.total
          this.searchItem = params
        } else {
          alertMessage.error('Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      // alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*overView tab 3*/
  @action
  async onSearchMsgListIndexAction(params, pageNo, pageSize) {
    this.isFetching = true
    this.messageList = []
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.itemCount = 0
    try {
      const response = await api.searchMsgListIndexAction(params, pageNo ? pageNo : 1, pageSize ? pageSize : this.pageSize)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          if (response.data.data === null) {
            alertMessage.error('Failed！ Data Platfrom no data!')
          } else {
            this.messageList = response.data.data.records.sort(function (a, b) {
              return a.startTime < b.startTime ? 1 : -1
            }) || []
            // this.messageList = this.allMessageList.slice(0,this.pageSize)
            this.itemCount = response.data.data?.total
            this.searchItem = params
          }
        } else {
          console.log(111111111111111)
          alertMessage.error(response.data.messageEn)
        }
      })
    } catch (error) {
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*overView indexNames*/
  @observable indexNames = []

  @action
  async searchMsgOverviewIndexName(params) {
    this.indexNames = []
    try {
      const response = await api.searchMsgOverviewIndexNameAction(params)
      runInAction(() => {
        if (response.data.code === 0) {
          if (response.data.data === null) {
            alertMessage.error('Failed！ Data Platfrom no data!')
          } else {
            var indexNameList = []
            var indexNameGroupList = []
            response.data.data.indexManagementList.map(item => indexNameList.push(item.indexName))
            response.data.data.indexManagementGroupList.map(item => indexNameList.push(item.groupName))
            this.indexNames = indexNameList.concat(indexNameGroupList).sort() || []
          }
        } else {
          alertMessage.error(response.data.messageEn)
        }
      })
    } catch (error) {
      runInAction(() => {
      })
    }
  }

  @observable messageDetailLog = []

  @action
  async onSearchMsgDetailLogAction(params, pageNo, pageSize) {
    this.isFetchingPayload = true
    this.messageDetailLog = []
    try {
      const response = await api.searchMsgDetailLogAction(params, pageNo, pageSize)
      runInAction(() => {
        this.isFetchingPayload = false
        if (response.data.code === 0) {
          this.messageDetailLog = response.data.data.records || []
        } else {
          alertMessage.error(response.data.messageEn)
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
        this.isFetchingPayload = false
      })
    }
  }

  @observable messageDetailFormat = ''
  @observable messageDetail = {}

  @action
  async onSearchMsgDetailFormatAction(params) {
    this.isFetching = true
    this.messageDetailFormat = ''
    try {
      const response = await api.searchMsgDetailFormatAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.messageDetail = response.data.data
          this.messageDetailFormat = response.data.data.data?.replace(/\n/g, '')
        } else {
          alertMessage.error(response.data.messageEn)
        }
      })
      console.log('response2', response)
      return response
    } catch (err) {
      // alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSearchMessageLogAction(requestId) {
    this.isFetchingLog = true
    this.messageLog = []
    try {
      await api.searchMsgLogAction(requestId)
        .then(res => {
            runInAction(() => {
              this.isFetchingLog = false
              if (res.data.code === 0) {
                this.messageLog = res.data.data || []
              }
            })
          }
        )
    } catch (err) {
      // alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingLog = false
      })
    }
  }

  @action
  async onResendMsgAction(payloadBody, type) {
    if (type === 1) {
      this.isFetching = true
    } else {
      this.isFetchingPayload = true
    }
    try {
      const response = await api.resendMsgAction(payloadBody)
      runInAction(() => {
        if (type === 1) {
        } else {
          this.isFetchingPayload = false
        }
        if (response.data.code === 0) {
          const params = []
          // response.data.data.data.map(item=> {return params.push({
          //   code:item.code,
          //   dataType:item.dataType,
          //   requestId:item.requestId,
          //   messageId:item.messageId,
          //   message:item.message
          // })})
          // alertMessage.success({
          //   content: <div style={{marginTop:'-20px', background: 'white', position: 'relative', zIndex:100}}>
          //     {params.map(item => <p><Text style={{paddingRight:10}}>{item.dataType==='INBOUND'?item.requestId:item.messageId}</Text><Text type={item.code===200?"success":'danger'}>{item.message}</Text></p>)}
          //   </div>,
          // })
          response.data.data.data.map(item => {
            return params.push({
              executionStatus: item.executionStatus,
              messageId: item.messageId,
              message: item.message
            })
          })
          alertMessage.success({
            content: <div style={{marginTop: '-20px', background: 'white', position: 'relative', zIndex: 100}}>
              {params.map(item => <p><Text style={{paddingRight: 10}}>{item.messageId}</Text><Text
                type={item.executionStatus === 'SUCCESSFUL' ? 'success' : 'danger'}>{item.message}</Text></p>)}
            </div>,
          })
          if (this.tabsValue === 'APIInformationSearch') {
            this.searchMessageOverview(this.searchItem, this.pageNo, this.pageSize)
          }
          if (this.tabsValue === 'identificationSearch') {
            this.onSearchMsgListAction(this.searchItem)
          }
          if (this.tabsValue === 'indexSearch') {
            this.onSearchMsgListIndexAction(this.searchItem)
          }
        } else {
          alertMessage.error('Resend Failed！' + response.data?.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching=false
        if (type === 1) {
        } else {
          this.isFetchingPayload = false
        }
      })
    }
  }

  /*resend outbound scheduled*/
  @action
  async onResendScheduledAction(payloadBody, type) {
    if (type === 1) {
      this.isFetching = true
    } else {
      this.isFetchingPayload = true
    }
    try {
      const response = await api.resendScheduledAction(payloadBody)
      runInAction(() => {
        if (type === 1) {
        } else {
          this.isFetchingPayload = false
        }
        if (response.data.code === 200) {
          alertMessage.success('Resend Success！')
          if (this.tabsValue === 'APIInformationSearch') {
            this.searchMessageOverview(this.searchItem, this.pageNo, this.pageSize)
          }
          if (this.tabsValue === 'identificationSearch') {
            this.onSearchMsgListAction(this.searchItem)
          }
          if (this.tabsValue === 'indexSearch') {
            this.onSearchMsgListIndexAction(this.searchItem)
          }
        } else {
          alertMessage.error('Resend Failed！' + response.data?.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        if (type === 1) {
        } else {
          this.isFetchingPayload = false
        }
      })
    }
  }

  @action
  async onSearchPayloadDetailAction(logId) {
    this.isFetching = true
    this.messagePayload = {}
    try {
      const response = await api.searchPayloadDetailAction(logId)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 200) {
          this.messagePayload = response.data.data || {}
        }
      })
    } catch (err) {
      // alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize, searchParams) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    // if(this.tabsValue==='APIInformationSearch'|| (this.tabsValue==='identificationSearch' && searchParams!==undefined)){
    if (this.tabsValue === 'APIInformationSearch') {
      this.searchMessageOverview(this.searchItem, pageNo, pageSize, searchParams)
    }
    // if(this.tabsValue==='identificationSearch'&& searchParams===undefined){
    if (this.tabsValue === 'identificationSearch') {
      this.onSearchMsgListAction(this.searchItem, this.pageNo, this.pageSize)
    }
    if (this.tabsValue === 'indexSearch') {
      this.onSearchMsgListIndexAction(this.searchItem, this.pageNo, this.pageSize)
    }
  }

  @observable messageIdList = []

  @action
  onChangeMessageIdList(value) {
    this.messageIdList = value
  }

  @action
  onChangePageNo(pageNo, pageSize) {
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.messageList = this.allMessageList.slice((pageNo - 1) * pageSize, pageNo * pageSize)
  }

  @action
  onChangeSearchItem(values) {
    this.searchItem = values
  }

  @action
  resetMessageList(){
    this.messageList=[]
  }
}
